import { chakra, Flex } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

interface CollapsibleFlexProps {
  className?: string;
}

/**
 * A basic flex container that goes to column mode on mobile
 */
export default chakra(function CollapsibleFlex({
  className,
  children
}: PropsWithChildren<CollapsibleFlexProps>) {
  return (
    <Flex className={className} flexDir={{ lg: 'row', base: 'column' }}>
      {children}
    </Flex>
  );
})
